import React from "react";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit_black_24dp.svg";
import { ReactComponent as TickIcon } from "../../../assets/icons/check_black_24dp.svg";
import { ReactComponent as TrashIcon } from "../../../assets/icons/trash.svg";
import { CircularProgress } from "@mui/material";

/**
 * Compact icon action buttons designed for tool bars
 * Features: No box-shadow, no border-radius, snug layout
 * Colors: orange and green for action grouping
 */
const IconActionButton = (props) => {
  const {
    icon,
    color = "orange", // "orange" or "green"
    disabled = false,
    onClick,
    loading = false,
    title = "", // For tooltip
  } = props;

  let iconElement;
  if (icon) {
    switch (icon) {
      case "edit": {
        iconElement = <EditIcon className="icon-action-button__icon" />;
        break;
      }
      case "tick": {
        iconElement = <TickIcon className="icon-action-button__icon" />;
        break;
      }
      case "trash": {
        iconElement = (
          <TrashIcon className="icon-action-button__icon icon-action-button__no-fill" />
        );
        break;
      }
      default:
        iconElement = null;
    }
  }

  const className =
    "icon-action-button " +
    (disabled ? "icon-action-button--disabled " : "") +
    (color ? `icon-action-button--${color} ` : "");

  return (
    <div
      className={className}
      onClick={() => {
        if (disabled || loading) {
          return;
        }
        onClick && onClick();
      }}
      title={title}
      role="button"
      tabIndex={0}
    >
      {loading ? (
        <CircularProgress size={16} style={{ color: "#FFFFFF" }} />
      ) : (
        iconElement
      )}
    </div>
  );
};

export default IconActionButton;
